import request from '@/http/request'

export const getVendor = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-tunnel-machine-configuration/getVendor`)
}
